export const normalizeWhitespace = (text: string): string =>
  text.replace(/[\s\p{Z}\u200B-\u200D\uFEFF]+/gu, ' ').trim();

export const isTextEmpty = (text: string) => !normalizeWhitespace(text).length;

export const removeWhitespaces = (text: string): string => {
  return text.replace(/\s+/g, '');
};

// https://stackoverflow.com/questions/11089399/count-with-a-b-c-d-instead-of-0-1-2-3-with-javascript
export const convertNumberToLetters = (num: number): string => {
  const mod = num % 26;
  // eslint-disable-next-line no-bitwise
  let pow = (num / 26) | 0;
  const out = mod ? String.fromCharCode(64 + mod) : (--pow, 'Z');

  return pow ? convertNumberToLetters(pow) + out : out;
};
